import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import WorkFlowStepUser from "./WorkFlowStepUser";
import GridConfig from "../GridConfig";

export default class WorkFlowStepUsers extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            workFlowStepId: props.WorkFlowStepId,
            solutionId: props.SolutionId,
            controllerName: 'solution/workflow/step/user',
            data: null,
            loading: true,
            configName: 'workflowstepusers_grid',
            moduleName: 'مسئولین و مجریان مراحله کاری'
        };
        this.state.filters = {
            workFlowStepId: this.state.workFlowStepId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <WorkFlowStepUser Caller={this} Id={id} WorkFlowStepId={this.state.workFlowStepId} SolutionId={this.state.solutionId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <WorkFlowStepUser Caller={this} WorkFlowStepId={this.state.workFlowStepId} SolutionId={this.state.solutionId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "personName", caption: "مسئول / مجری", show: true },
                { field: "solutionRoleName", caption: "نقش", show: true },
                { field: "createDateString", caption: "تاریخ ثبت", show: false },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'personName' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.personName}</a> } });
            if (f.field == 'solutionRoleName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">مسئولین و مجریان مرحله کاری</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, { add: true, print: true, pdf: true, excell: true, remove: true, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}